export default o => Object.prototype.toString.call(o) === "[object Object]";
